import { QuoteStateCode } from '@/lib/types'

export const CPQ_VERSION_2_CUTOFF_DATE = new Date('2025-11-05T08:00:00.000Z')

export function cpqVersionForQuote(
  quote: { statecode: QuoteStateCode; dsy_approvalsignaturedatetime: string | null } | undefined
) {
  if (
    quote?.statecode === QuoteStateCode.Draft ||
    quote?.statecode === QuoteStateCode.Active ||
    (quote?.dsy_approvalsignaturedatetime && new Date(quote.dsy_approvalsignaturedatetime) >= CPQ_VERSION_2_CUTOFF_DATE)
  ) {
    return 2
  }

  return 1
}
